import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./CompanyPageStyles.module.css";
import Wizard from "../../CompanyDashboard/CompanyContent/Wizard";

const CompanyPage = () => {
  /* ---------- basic setup ---------- */
  const { id } = useParams(); // company admin‑code from URL
  const admincode = id;
  const navigate = useNavigate();

  const companyName =
    localStorage.getItem("clickedCompanyName") || "No Company";
  const imageFile = localStorage.getItem("clickedImageFile") || "";
  const imageUrl = imageFile
    ? `https://starbehaviors.com/uploadimage/${imageFile}`
    : "";

  /* ---------- state ---------- */
  const [departments, setDepartments] = useState([]);
  const [loadingDepts, setLoadingDepts] = useState(false);
  const [deptError, setDeptError] = useState("");

  const [filledDepts, setFilledDepts] = useState([]);

  const [masterDepts, setMasterDepts] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [assignMessage, setAssignMessage] = useState("");

  /* ---------- data fetch helpers ---------- */
  const fetchAssignedDepartments = async () => {
    setLoadingDepts(true);
    setDeptError("");
    try {
      const res = await axios.post(
        "https://casaahaanahotels.com/get_company_departments",
        { companycode: admincode }
      );
      setDepartments(res.data?.departments || []);
    } catch (err) {
      console.error("Error fetching assigned departments:", err);
      setDeptError("No departments assigned.");
    } finally {
      setLoadingDepts(false);
    }
  };

  const fetchFilledDepartments = async () => {
    try {
      const res = await axios.post(
        "https://casaahaanahotels.com/get_departments_by_company",
        { company_code: admincode }
      );
      setFilledDepts(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching filled departments:", err);
    }
  };

  const fetchMasterDepartments = async () => {
    try {
      const res = await axios.post(
        "https://casaahaanahotels.com/get_master_assessment_type",
        {}
      );
      setMasterDepts(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Error fetching master departments:", err);
    }
  };

  useEffect(() => {
    fetchAssignedDepartments();
    fetchFilledDepartments();
    fetchMasterDepartments();
  }, [admincode]);

  /* ---------- helpers ---------- */
  const isDepartmentReady = (assigned) =>
    filledDepts.some(
      (filled) => filled.company_department === assigned.departmentcode
    );

  const getFilledDepartment = (assigned) =>
    filledDepts.find(
      (filled) => filled.company_department === assigned.departmentcode
    );

  /* ---------- handle assign ---------- */
  const handleAssignDepartment = async () => {
    if (!selectedDept) {
      setAssignMessage("Please select a department type.");
      return;
    }
    setAssignMessage("");
    try {
      const res = await axios.post(
        "https://casaahaanahotels.com/add_assessment_type",
        { companycode: admincode, departmentcode: selectedDept }
      );
      if (res.data?.message === "Department type added successfully.") {
        setAssignMessage("Department assigned successfully.");
        setTimeout(() => window.location.reload(), 1500);
      } else {
        setAssignMessage(res.data?.error || "Failed to assign department.");
      }
    } catch (err) {
      console.error("Error assigning department:", err);
      setAssignMessage("Department already assigned");
    }
  };

  /* ---------- navigation handlers ---------- */
  const handleFillDetails = (dept) =>
    navigate(
      `/company/view-company/${admincode}/company-assessment/${dept.departmentcode}`
    );

  const [showModal, setShowModal] = useState(false);
  const [previewDept, setPreviewDept] = useState(null);
  // const handleShowReview = (filledDept) => {
  //   if (filledDept?.admincode)
  //     window.open(`/user-landingpage/${filledDept.admincode}`, "_blank");
  // };
  const handleShowReview = (filledDept) => {
    setPreviewDept(filledDept?.admincode);
    setShowModal(true);

    // if (filledDept?.admincode)
    //   window.open(`/user-landingpage/${filledDept.admincode}`, "_blank");
  };

    const handleDevicePreview = (device) => {
    if (previewDept) {
      const url = `/user-landingpage/${previewDept}?view=${device}`;
      window.open(url, "_blank");
      setShowModal(false);
    }
  };

   const modalRef = useRef(null);
  
    useEffect(() => {
      function handleOutsideClick(event) {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          setShowModal(false);
        }
      }
  
      if (showModal) {
        document.addEventListener('mousedown', handleOutsideClick);
      } else {
        document.removeEventListener('mousedown', handleOutsideClick);
      }
  
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
      };
    }, [showModal]);

  /* ---------- render ---------- */
  return (
    <div className={styles.companyPageContainer}>
      <Wizard currentStep={2} />

      <h1 className={styles.companyPageTitle}>{companyName}</h1>

      {imageUrl && (
        <div className={styles.imageWrapper}>
          <img
            src={imageUrl}
            alt={companyName}
            className={styles.companyImage}
          />
        </div>
      )}

      <hr className={styles.sectionDivider} />

      {/* ---------------- Departments ---------------- */}
      <div className={styles.departmentsSection}>
        <h2 className={styles.sectionHeading}>Departments</h2>

        {loadingDepts ? (
          <p>Loading departments...</p>
        ) : deptError ? (
          <p>{deptError}</p>
        ) : departments.length === 0 ? (
          <p>No Department assigned</p>
        ) : (
          <div className={styles.departmentCards}>
            {departments.map((dept) => {
              const ready = isDepartmentReady(dept);
              const matchingMaster = masterDepts.find(
                (md) => md.assessment_type_id === dept.departmentcode
              );
              const departmentName =
                matchingMaster?.AssessmentType || "Unknown Department";
              const filledDept = getFilledDepartment(dept);

              return (
                <div
                  key={dept.department_assignment_id}
                  className={styles.departmentCard}
                >
                  <p className={styles.departmentName}>{departmentName}</p>

                  {ready ? (
                    <>
                      <p className={styles.readyStatus}>
                        <span className={styles.readyDot}></span>
                        Assessment Ready
                      </p>

                      {/* two buttons: preview (new tab) + open (same tab) */}
                      <div
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          className={styles.actionButton}
                          onClick={() => handleShowReview(filledDept)}
                        >
                          Preview
                        </button>

                        <button
                          className={styles.actionButton}
                          onClick={() =>
                            filledDept?.admincode &&
                            navigate(`${filledDept.admincode}`)
                          }
                        >
                          Edit
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className={styles.notReadyStatus}>
                        <span className={styles.notReadyDot}></span>
                        Not Filled
                      </p>
                      <button
                        className={styles.actionButton}
                        onClick={() => handleFillDetails(dept)}
                      >
                        Fill Details
                      </button>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <hr className={styles.sectionDivider} />



       {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            ref={modalRef}
            style={{
              backgroundColor: 'white',
              padding: '30px 40px',
              borderRadius: '10px',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
              minWidth: '300px',
            }}
          >
            <h3 style={{ color: '#202A77', fontSize: '24px', marginBottom: '20px' }}>
              Choose Preview Mode
            </h3>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
              <button
                onClick={() => handleDevicePreview('mobile')}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f7f7f7',
                  border: '1px solid black',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                Mobile
              </button>
              <button
                onClick={() => handleDevicePreview('tablet')}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f7f7f7',
                  border: '1px solid black',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                Tablet
              </button>
              <button
                onClick={() => handleDevicePreview('desktop')}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f7f7f7',
                  border: '1px solid black',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                Desktop
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyPage;
